export {
  API_URL,
} from '@kaidam/fc-shared/src/constants'

export const REFRESH_TOKEN_DELAY = 1000 * 60

export const ROUTE_LOGGED_IN = 'home'
export const ROUTE_LOGGED_OUT = 'home'

export const TOPBAR_HEIGHT = 90
export const APP_TITLE = 'First Thermal Booking'
export const APP_LOGO = '/img/logos/firstthermal-logo.png'
export const APP_PALETTE = {
  primary: {
    main: '#B23C86',
  },
  secondary: {
    main: '#005C67',
  },
  background: {
    default: '#FAFBFF',
  },
}
